"use client";

import type { ReactNode } from "react";
import { ConvexProvider } from "convex/react";
import { createBrowserConvexClient } from "@/lib/convex/traced-client";
import { safeWebSocketConstructor } from "@/lib/safe-websocket";

const publicConvex = createBrowserConvexClient(process.env.NEXT_PUBLIC_CONVEX_URL!, {
  webSocketConstructor: safeWebSocketConstructor(),
});

export function PublicConvexProvider({ children }: { children: ReactNode }) {
  return <ConvexProvider client={publicConvex}>{children}</ConvexProvider>;
}
